var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"root"}},[_c('tabs',[_c('tab',{attrs:{"name":"Game","selected":true}},[_c('tournament-list',{attrs:{"model":this.tournament_data}})],1),_vm._v(" "),_c('tab',{attrs:{"name":"Leaderboard"}},[_c('leader-board',{attrs:{"model":this.leaderboard_data}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458a05fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/main_page.vue
// module id = null
// module chunks = 